import { emitErrors } from './PostMessageHelpers';

async function updateForm(
  event: any,
  eventType: string,
  form: any,
  setForm: any,
  validationSchema: any
) {
  const target = event.target;
  const newForm: any = form;
  newForm[target.name] = target.value;
  setForm(newForm);
  emitErrors(eventType, await validateForm(newForm, validationSchema));
}

async function validateForm(formValues: any, validationSchema: any): Promise<string[]> {
  return await validationSchema
    .validate(formValues, { abortEarly: false })
    .then(function () {
      return [];
    })
    .catch(function (err: any) {
      const paths: string[] = [];
      const errors: string[] = [];
      err.inner.forEach((error: any) => {
        const errorForFieldAlreadyExists = paths.includes(error.path);
        if (errorForFieldAlreadyExists) return;
        paths.push(error.path);
        errors.push(`${error.path}_${error.type ? error.type : 'invalid'}`);
      });
      return errors;
    });
}

export { updateForm, validateForm };
